module.exports = __webpack_public_path__ + "img/flinkk-logo-xs.48cda84a.png";